/** Bullet / target bands (D529): where a value sits against a target and a few qualitative ranges. */
import { clamp, fraction, isFiniteNumber } from './numbers.js';
/** Lay out a bullet gauge. Non-finite inputs are repaired (the axis never collapses or divides by zero). */
export function bulletLayout(input) {
    const value = isFiniteNumber(input.value) ? input.value : 0;
    const target = isFiniteNumber(input.target) ? input.target : null;
    const limits = (input.bands ?? []).filter(isFiniteNumber).sort((a, b) => a - b);
    const min = isFiniteNumber(input.min) ? input.min : Math.min(0, value, target ?? 0, limits[0] ?? 0);
    let max = isFiniteNumber(input.max) ? input.max : Math.max(value, target ?? min, ...limits);
    if (max <= min)
        max = min + 1;
    const share = (v) => clamp(fraction(v - min, max - min), 0, 1);
    const bands = [];
    let from = min;
    limits.forEach((to, index) => {
        const upper = Math.min(to, max);
        if (upper > from)
            bands.push({ index: bands.length, from, to: upper, fromShare: share(from), toShare: share(upper) });
        else if (index === 0)
            return;
        from = Math.max(from, upper);
    });
    const bandIndex = bands.length === 0 ? null : (() => {
        const i = bands.findIndex((b, k) => value < b.to || k === bands.length - 1);
        return i < 0 ? bands.length - 1 : i;
    })();
    const higher = input.higherIsBetter ?? true;
    return {
        domain: [min, max],
        bands,
        valueShare: share(value),
        targetShare: target === null ? null : share(target),
        bandIndex,
        attainment: target === null || target === 0 ? null : value / target,
        reached: target === null ? null : higher ? value >= target : value <= target,
    };
}
//# sourceMappingURL=bullet.js.map